import React, { useContext, MouseEventHandler, useCallback } from 'react';
import theme from './NavigationContextMenu.module.scss';
import { CustomNavLinkProps, CustomNavLink } from '@/components/navigation/base';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import NavigationContextMenuItem, { ExternalNavigationContextMenuItemProps } from './NavigationContextMenuItem';
import NavigationContextMenuContext from './NavigationContextMenuContext';

type NavigationContextMenuInternalLinkItemProps = ExternalNavigationContextMenuItemProps &
    Pick<CustomNavLinkProps, 'to' | 'isActive' | 'exact'> & {
        icon?: IconProp;
        showActiveState?: boolean;
    };

const NavigationContextMenuInternalLinkItem: React.FC<NavigationContextMenuInternalLinkItemProps> = ({
    title,
    subtitle,
    icon,
    imageElement,
    children,
    disabled,
    to,
    isActive,
    exact,
    showActiveState = false,
}) => {
    const itemProp: ExternalNavigationContextMenuItemProps = {
        title,
        subtitle,
        icon,
        imageElement,
    };

    const context = useContext(NavigationContextMenuContext);

    const handleClick: MouseEventHandler<any> = useCallback(
        (e) => {
            if (disabled) {
                e.preventDefault();
                return;
            }

            context.toggle(false);
        },
        [context, disabled]
    );

    return (
        <NavigationContextMenuItem
            clickable
            disabled={disabled}
            {...itemProp}
            wrapper={
                <CustomNavLink
                    onClick={handleClick}
                    exact={exact}
                    to={to}
                    tabIndex={context.open ? undefined : -1}
                    isActive={isActive}
                    activeClassName={showActiveState ? theme.active : undefined}
                />
            }>
            {children}
        </NavigationContextMenuItem>
    );
};

export default NavigationContextMenuInternalLinkItem;
